var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#0DCA5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21C16.2833 21 16.521 20.904 16.713 20.712C16.905 20.52 17.0007 20.2827 17 20C16.9993 19.7173 16.9033 19.48 16.712 19.288C16.5207 19.096 16.2833 19 16 19C15.7167 19 15.4793 19.096 15.288 19.288C15.0967 19.48 15.0007 19.7173 15 20C14.9993 20.2827 15.0953 20.5203 15.288 20.713C15.4807 20.9057 15.718 21.0013 16 21ZM15 17H17V11H15V17ZM12.25 25L7 19.75V12.25L12.25 7H19.75L25 12.25V19.75L19.75 25H12.25ZM13.1 23H18.9L23 18.9V13.1L18.9 9H13.1L9 13.1V18.9L13.1 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.c1cf90b224c78167c6670c482aaa4e1f.svg";
export { ForwardRef as ReactComponent };